export default {"src":"https://dap-prod-3m8r9mc2a-dap-rewrite.vercel.app/_next/static/media/icon-marker.67e1b489.svg","height":28,"width":22};